import window$1 from 'global/window';
import 'webvr-polyfill/src/main';
import videojs from 'video.js';
import { BufferGeometry, CubeGeometry, DoubleSide, LinearFilter, Matrix4, Mesh, MeshBasicMaterial, PerspectiveCamera, Quaternion, RGBAFormat, RGBFormat, Scene, ShaderMaterial, SphereBufferGeometry, SphereGeometry, Vector2, Vector3, VideoTexture, WebGLRenderer } from 'three';
import * as THREE from 'three';
import WebVRManager from 'webvr-boilerplate/build/webvr-manager';

var version = "1.0.2";

// this is used to configure webvr-polyfill
// see https://github.com/googlevr/webvr-polyfill#configuration
var WebVRConfig = {
  // TODO:
  // implement controls so that thy only work when the player is in focus.
  // This will require MOUSE_KEYBOARD_CONTROLS_DISABLED, and TOUCH_PANNER_DISABLED to be set to true
  // and various points in the code will have to be changed. As a lot of the code
  // expects some sort of controls to be set up, and when no controls are set up
  // it throws an error about no vr displays being found. VrDisplays is actually referring to controls.

  // Flag to disable touch panner. In case you have your own touch controls.
  // Default: true.
  TOUCH_PANNER_DISABLED: false
  // To disable keyboard and mouse controls, if you want to use your own
  // implementation.
  // Default: false.
  // MOUSE_KEYBOARD_CONTROLS_DISABLED: true,
};

window$1.WebVRConfig = WebVRConfig;

/**
 * NOTE THAT THIS CODE WAS NOT WRITTEN BY US!
 *
 * This code is a slightly modified version of code from three.js to allow for an
 * export of the VRControls variable from an example. The original code can be found here:
 *   * https://github.com/mrdoob/three.js/blob/dev/examples/js/controls/VRControls.js
 *   * node_modules/three/examples/js/controls/VRControls.js
 *
 * NOTE THAT THIS CODE WAS NOT WRITTEN BY US!
 **/
/**
 * @author dmarcos / https://github.com/dmarcos
 * @author mrdoob / http://mrdoob.com
 */

var VRControls = function VRControls(object, onError) {

	var scope = this;

	var vrDisplay, vrDisplays;

	var standingMatrix = new Matrix4();

	var frameData = null;

	if ('VRFrameData' in window) {

		frameData = new VRFrameData();
	}

	function gotVRDisplays(displays) {

		vrDisplays = displays;

		if (displays.length > 0) {

			vrDisplay = displays[0];
		} else {

			if (onError) onError('VR input not available.');
		}
	}

	if (navigator.getVRDisplays) {

		navigator.getVRDisplays().then(gotVRDisplays).catch(function () {

			console.warn('THREE.VRControls: Unable to get VR Displays');
		});
	}

	// the Rift SDK returns the position in meters
	// this scale factor allows the user to define how meters
	// are converted to scene units.

	this.scale = 1;

	// If true will use "standing space" coordinate system where y=0 is the
	// floor and x=0, z=0 is the center of the room.
	this.standing = false;

	// Distance from the users eyes to the floor in meters. Used when
	// standing=true but the VRDisplay doesn't provide stageParameters.
	this.userHeight = 1.6;

	this.getVRDisplay = function () {

		return vrDisplay;
	};

	this.setVRDisplay = function (value) {

		vrDisplay = value;
	};

	this.getVRDisplays = function () {

		console.warn('THREE.VRControls: getVRDisplays() is being deprecated.');
		return vrDisplays;
	};

	this.getStandingMatrix = function () {

		return standingMatrix;
	};

	this.update = function () {

		if (vrDisplay) {

			var pose;

			if (vrDisplay.getFrameData) {

				vrDisplay.getFrameData(frameData);
				pose = frameData.pose;
			} else if (vrDisplay.getPose) {

				pose = vrDisplay.getPose();
			}

			if (pose.orientation !== null) {

				object.quaternion.fromArray(pose.orientation);
			}

			if (pose.position !== null) {

				object.position.fromArray(pose.position);
			} else {

				object.position.set(0, 0, 0);
			}

			if (this.standing) {

				if (vrDisplay.stageParameters) {

					object.updateMatrix();

					standingMatrix.fromArray(vrDisplay.stageParameters.sittingToStandingTransform);
					object.applyMatrix(standingMatrix);
				} else {

					object.position.setY(object.position.y + this.userHeight);
				}
			}

			object.position.multiplyScalar(scope.scale);
		}
	};

	this.dispose = function () {

		vrDisplay = null;
	};
};

/**
 * NOTE THAT THIS CODE WAS NOT WRITTEN BY US!
 *
 * This code is a slightly modified version of code from three.js to allow for an
 * export of the VREffect variable from an example. The original code can be found here:
 *   * https://github.com/mrdoob/three.js/blob/dev/examples/js/effects/VREffect.js
 *   * node_modules/three/examples/js/effects/VREffect.js
 *
 * NOTE THAT THIS CODE WAS NOT WRITTEN BY US!
 **/
/**
 * @author dmarcos / https://github.com/dmarcos
 * @author mrdoob / http://mrdoob.com
 *
 * WebVR Spec: http://mozvr.github.io/webvr-spec/webvr.html
 *
 * Firefox: http://mozvr.com/downloads/
 * Chromium: https://webvr.info/get-chrome
 *
 */
var VREffect = function VREffect(renderer, onError) {

	var vrDisplay, vrDisplays;
	var eyeTranslationL = new Vector3();
	var eyeTranslationR = new Vector3();
	var renderRectL, renderRectR;
	var headMatrix = new Matrix4();
	var eyeMatrixL = new Matrix4();
	var eyeMatrixR = new Matrix4();

	var frameData = null;

	if ('VRFrameData' in window) {

		frameData = new window.VRFrameData();
	}

	function gotVRDisplays(displays) {

		vrDisplays = displays;

		if (displays.length > 0) {

			vrDisplay = displays[0];
		} else {

			if (onError) onError('HMD not available');
		}
	}

	if (navigator.getVRDisplays) {

		navigator.getVRDisplays().then(gotVRDisplays).catch(function () {

			console.warn('THREE.VREffect: Unable to get VR Displays');
		});
	}

	//

	this.isPresenting = false;

	var scope = this;

	var rendererSize = renderer.getSize();
	var rendererUpdateStyle = false;
	var rendererPixelRatio = renderer.getPixelRatio();

	this.getVRDisplay = function () {

		return vrDisplay;
	};

	this.setVRDisplay = function (value) {

		vrDisplay = value;
	};

	this.getVRDisplays = function () {

		console.warn('THREE.VREffect: getVRDisplays() is being deprecated.');
		return vrDisplays;
	};

	this.setSize = function (width, height, updateStyle) {

		rendererSize = { width: width, height: height };
		rendererUpdateStyle = updateStyle;

		if (scope.isPresenting) {

			var eyeParamsL = vrDisplay.getEyeParameters('left');
			renderer.setPixelRatio(1);
			renderer.setSize(eyeParamsL.renderWidth * 2, eyeParamsL.renderHeight, false);
		} else {

			renderer.setPixelRatio(rendererPixelRatio);
			renderer.setSize(width, height, updateStyle);
		}
	};

	// VR presentation

	var canvas = renderer.domElement;
	var defaultLeftBounds = [0.0, 0.0, 0.5, 1.0];
	var defaultRightBounds = [0.5, 0.0, 0.5, 1.0];

	function onVRDisplayPresentChange() {

		var wasPresenting = scope.isPresenting;
		scope.isPresenting = vrDisplay !== undefined && vrDisplay.isPresenting;

		if (scope.isPresenting) {

			var eyeParamsL = vrDisplay.getEyeParameters('left');
			var eyeWidth = eyeParamsL.renderWidth;
			var eyeHeight = eyeParamsL.renderHeight;

			if (!wasPresenting) {

				rendererPixelRatio = renderer.getPixelRatio();
				rendererSize = renderer.getSize();

				renderer.setPixelRatio(1);
				renderer.setSize(eyeWidth * 2, eyeHeight, false);
			}
		} else if (wasPresenting) {

			renderer.setPixelRatio(rendererPixelRatio);
			renderer.setSize(rendererSize.width, rendererSize.height, rendererUpdateStyle);
		}
	}

	window.addEventListener('vrdisplaypresentchange', onVRDisplayPresentChange, false);

	this.setFullScreen = function (boolean) {

		return new Promise(function (resolve, reject) {

			if (vrDisplay === undefined) {

				reject(new Error('No VR hardware found.'));
				return;
			}

			if (scope.isPresenting === boolean) {

				resolve();
				return;
			}

			if (boolean) {

				resolve(vrDisplay.requestPresent([{ source: canvas }]));
			} else {

				resolve(vrDisplay.exitPresent());
			}
		});
	};

	this.requestPresent = function () {

		return this.setFullScreen(true);
	};

	this.exitPresent = function () {

		return this.setFullScreen(false);
	};

	this.requestAnimationFrame = function (f) {

		if (vrDisplay !== undefined) {

			return vrDisplay.requestAnimationFrame(f);
		} else {

			return window.requestAnimationFrame(f);
		}
	};

	this.cancelAnimationFrame = function (h) {

		if (vrDisplay !== undefined) {

			vrDisplay.cancelAnimationFrame(h);
		} else {

			window.cancelAnimationFrame(h);
		}
	};

	this.submitFrame = function () {

		if (vrDisplay !== undefined && scope.isPresenting) {

			vrDisplay.submitFrame();
		}
	};

	this.autoSubmitFrame = true;

	// render

	var cameraL = new PerspectiveCamera();
	cameraL.layers.enable(1);

	var cameraR = new PerspectiveCamera();
	cameraR.layers.enable(2);

	this.render = function (scene, camera, renderTarget, forceClear) {

		if (vrDisplay && scope.isPresenting) {

			var autoUpdate = scene.autoUpdate;

			if (autoUpdate) {

				scene.updateMatrixWorld();
				scene.autoUpdate = false;
			}

			if (Array.isArray(scene)) {

				console.warn('THREE.VREffect.render() no longer supports arrays. Use object.layers instead.');
				scene = scene[0];
			}

			// When rendering we don't care what the recommended size is, only what the actual size
			// of the backbuffer is.
			var size = renderer.getSize();
			var layers = vrDisplay.getLayers();
			var leftBounds;
			var rightBounds;

			if (layers.length) {

				var layer = layers[0];

				leftBounds = layer.leftBounds !== null && layer.leftBounds.length === 4 ? layer.leftBounds : defaultLeftBounds;
				rightBounds = layer.rightBounds !== null && layer.rightBounds.length === 4 ? layer.rightBounds : defaultRightBounds;
			} else {

				leftBounds = defaultLeftBounds;
				rightBounds = defaultRightBounds;
			}

			renderRectL = {
				x: Math.round(size.width * leftBounds[0]),
				y: Math.round(size.height * leftBounds[1]),
				width: Math.round(size.width * leftBounds[2]),
				height: Math.round(size.height * leftBounds[3])
			};
			renderRectR = {
				x: Math.round(size.width * rightBounds[0]),
				y: Math.round(size.height * rightBounds[1]),
				width: Math.round(size.width * rightBounds[2]),
				height: Math.round(size.height * rightBounds[3])
			};

			if (renderTarget) {

				renderer.setRenderTarget(renderTarget);
				renderTarget.scissorTest = true;
			} else {

				renderer.setRenderTarget(null);
				renderer.setScissorTest(true);
			}

			if (renderer.autoClear || forceClear) renderer.clear();

			if (camera.parent === null) camera.updateMatrixWorld();

			camera.matrixWorld.decompose(cameraL.position, cameraL.quaternion, cameraL.scale);

			cameraR.position.copy(cameraL.position);
			cameraR.quaternion.copy(cameraL.quaternion);
			cameraR.scale.copy(cameraL.scale);

			if (vrDisplay.getFrameData) {

				vrDisplay.depthNear = camera.near;
				vrDisplay.depthFar = camera.far;

				vrDisplay.getFrameData(frameData);

				cameraL.projectionMatrix.elements = frameData.leftProjectionMatrix;
				cameraR.projectionMatrix.elements = frameData.rightProjectionMatrix;

				getEyeMatrices(frameData);

				cameraL.updateMatrix();
				cameraL.matrix.multiply(eyeMatrixL);
				cameraL.matrix.decompose(cameraL.position, cameraL.quaternion, cameraL.scale);

				cameraR.updateMatrix();
				cameraR.matrix.multiply(eyeMatrixR);
				cameraR.matrix.decompose(cameraR.position, cameraR.quaternion, cameraR.scale);
			} else {

				var eyeParamsL = vrDisplay.getEyeParameters('left');
				var eyeParamsR = vrDisplay.getEyeParameters('right');

				cameraL.projectionMatrix = fovToProjection(eyeParamsL.fieldOfView, true, camera.near, camera.far);
				cameraR.projectionMatrix = fovToProjection(eyeParamsR.fieldOfView, true, camera.near, camera.far);

				eyeTranslationL.fromArray(eyeParamsL.offset);
				eyeTranslationR.fromArray(eyeParamsR.offset);

				cameraL.translateOnAxis(eyeTranslationL, cameraL.scale.x);
				cameraR.translateOnAxis(eyeTranslationR, cameraR.scale.x);
			}

			// render left eye
			if (renderTarget) {

				renderTarget.viewport.set(renderRectL.x, renderRectL.y, renderRectL.width, renderRectL.height);
				renderTarget.scissor.set(renderRectL.x, renderRectL.y, renderRectL.width, renderRectL.height);
			} else {

				renderer.setViewport(renderRectL.x, renderRectL.y, renderRectL.width, renderRectL.height);
				renderer.setScissor(renderRectL.x, renderRectL.y, renderRectL.width, renderRectL.height);
			}
			renderer.render(scene, cameraL, renderTarget, forceClear);

			// render right eye
			if (renderTarget) {

				renderTarget.viewport.set(renderRectR.x, renderRectR.y, renderRectR.width, renderRectR.height);
				renderTarget.scissor.set(renderRectR.x, renderRectR.y, renderRectR.width, renderRectR.height);
			} else {

				renderer.setViewport(renderRectR.x, renderRectR.y, renderRectR.width, renderRectR.height);
				renderer.setScissor(renderRectR.x, renderRectR.y, renderRectR.width, renderRectR.height);
			}
			renderer.render(scene, cameraR, renderTarget, forceClear);

			if (renderTarget) {

				renderTarget.viewport.set(0, 0, size.width, size.height);
				renderTarget.scissor.set(0, 0, size.width, size.height);
				renderTarget.scissorTest = false;
				renderer.setRenderTarget(null);
			} else {

				renderer.setViewport(0, 0, size.width, size.height);
				renderer.setScissorTest(false);
			}

			if (autoUpdate) {

				scene.autoUpdate = true;
			}

			if (scope.autoSubmitFrame) {

				scope.submitFrame();
			}

			return;
		}

		// Regular render mode if not HMD

		renderer.render(scene, camera, renderTarget, forceClear);
	};

	this.dispose = function () {

		window.removeEventListener('vrdisplaypresentchange', onVRDisplayPresentChange, false);
	};

	//

	var poseOrientation = new Quaternion();
	var posePosition = new Vector3();

	// Compute model matrices of the eyes with respect to the head.
	function getEyeMatrices(frameData) {

		// Compute the matrix for the position of the head based on the pose
		if (frameData.pose.orientation) {

			poseOrientation.fromArray(frameData.pose.orientation);
			headMatrix.makeRotationFromQuaternion(poseOrientation);
		} else {

			headMatrix.identity();
		}

		if (frameData.pose.position) {

			posePosition.fromArray(frameData.pose.position);
			headMatrix.setPosition(posePosition);
		}

		// The view matrix transforms vertices from sitting space to eye space. As such, the view matrix can be thought of as a product of two matrices:
		// headToEyeMatrix * sittingToHeadMatrix

		// The headMatrix that we've calculated above is the model matrix of the head in sitting space, which is the inverse of sittingToHeadMatrix.
		// So when we multiply the view matrix with headMatrix, we're left with headToEyeMatrix:
		// viewMatrix * headMatrix = headToEyeMatrix * sittingToHeadMatrix * headMatrix = headToEyeMatrix

		eyeMatrixL.fromArray(frameData.leftViewMatrix);
		eyeMatrixL.multiply(headMatrix);
		eyeMatrixR.fromArray(frameData.rightViewMatrix);
		eyeMatrixR.multiply(headMatrix);

		// The eye's model matrix in head space is the inverse of headToEyeMatrix we calculated above.

		eyeMatrixL.getInverse(eyeMatrixL);
		eyeMatrixR.getInverse(eyeMatrixR);
	}

	function fovToNDCScaleOffset(fov) {

		var pxscale = 2.0 / (fov.leftTan + fov.rightTan);
		var pxoffset = (fov.leftTan - fov.rightTan) * pxscale * 0.5;
		var pyscale = 2.0 / (fov.upTan + fov.downTan);
		var pyoffset = (fov.upTan - fov.downTan) * pyscale * 0.5;
		return { scale: [pxscale, pyscale], offset: [pxoffset, pyoffset] };
	}

	function fovPortToProjection(fov, rightHanded, zNear, zFar) {

		rightHanded = rightHanded === undefined ? true : rightHanded;
		zNear = zNear === undefined ? 0.01 : zNear;
		zFar = zFar === undefined ? 10000.0 : zFar;

		var handednessScale = rightHanded ? -1.0 : 1.0;

		// start with an identity matrix
		var mobj = new Matrix4();
		var m = mobj.elements;

		// and with scale/offset info for normalized device coords
		var scaleAndOffset = fovToNDCScaleOffset(fov);

		// X result, map clip edges to [-w,+w]
		m[0 * 4 + 0] = scaleAndOffset.scale[0];
		m[0 * 4 + 1] = 0.0;
		m[0 * 4 + 2] = scaleAndOffset.offset[0] * handednessScale;
		m[0 * 4 + 3] = 0.0;

		// Y result, map clip edges to [-w,+w]
		// Y offset is negated because this proj matrix transforms from world coords with Y=up,
		// but the NDC scaling has Y=down (thanks D3D?)
		m[1 * 4 + 0] = 0.0;
		m[1 * 4 + 1] = scaleAndOffset.scale[1];
		m[1 * 4 + 2] = -scaleAndOffset.offset[1] * handednessScale;
		m[1 * 4 + 3] = 0.0;

		// Z result (up to the app)
		m[2 * 4 + 0] = 0.0;
		m[2 * 4 + 1] = 0.0;
		m[2 * 4 + 2] = zFar / (zNear - zFar) * -handednessScale;
		m[2 * 4 + 3] = zFar * zNear / (zNear - zFar);

		// W result (= Z in)
		m[3 * 4 + 0] = 0.0;
		m[3 * 4 + 1] = 0.0;
		m[3 * 4 + 2] = handednessScale;
		m[3 * 4 + 3] = 0.0;

		mobj.transpose();

		return mobj;
	}

	function fovToProjection(fov, rightHanded, zNear, zFar) {

		var DEG2RAD = Math.PI / 180.0;

		var fovPort = {
			upTan: Math.tan(fov.upDegrees * DEG2RAD),
			downTan: Math.tan(fov.downDegrees * DEG2RAD),
			leftTan: Math.tan(fov.leftDegrees * DEG2RAD),
			rightTan: Math.tan(fov.rightDegrees * DEG2RAD)
		};

		return fovPortToProjection(fovPort, rightHanded, zNear, zFar);
	}
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// Add Cardboard button
var Button = videojs.getComponent('Button');

var CardboardButton = function (_Button) {
  inherits(CardboardButton, _Button);

  function CardboardButton(player, options) {
    classCallCheck(this, CardboardButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.handleVrDisplayActivate_ = videojs.bind(_this, _this.handleVrDisplayActivate_);
    _this.handleVrDisplayDeactivate_ = videojs.bind(_this, _this.handleVrDisplayDeactivate_);
    _this.handleVrDisplayPresentChange_ = videojs.bind(_this, _this.handleVrDisplayPresentChange_);
    _this.handleOrientationChange_ = videojs.bind(_this, _this.handleOrientationChange_);
    window$1.addEventListener('orientationchange', _this.handleOrientationChange_);
    window$1.addEventListener('vrdisplayactivate', _this.handleVrDisplayActivate_);
    window$1.addEventListener('vrdisplaydeactivate', _this.handleVrDisplayDeactivate_);

    // vrdisplaypresentchange does not fire activate or deactivate
    // and happens when hitting the back button during cardboard mode
    // so we need to make sure we stay in the correct state by
    // listening to it and checking if we are presenting it or not
    window$1.addEventListener('vrdisplaypresentchange', _this.handleVrDisplayPresentChange_);

    // we cannot show the cardboard button in fullscreen on
    // android as it breaks the controls, and makes it impossible
    // to exit cardboard mode
    if (videojs.browser.IS_ANDROID) {
      _this.on(player, 'fullscreenchange', function () {
        if (player.isFullscreen()) {
          _this.hide();
        } else {
          _this.show();
        }
      });
    }
    return _this;
  }

  CardboardButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-button-vr ' + _Button.prototype.buildCSSClass.call(this);
  };

  CardboardButton.prototype.handleVrDisplayPresentChange_ = function handleVrDisplayPresentChange_() {
    if (!this.player_.vr().vrDisplay.isPresenting && this.active_) {
      this.handleVrDisplayDeactivate_();
    }
    if (this.player_.vr().vrDisplay.isPresenting && !this.active_) {
      this.handleVrDisplayActivate_();
    }
  };

  CardboardButton.prototype.handleOrientationChange_ = function handleOrientationChange_() {
    if (this.active_ && videojs.browser.IS_IOS) {
      this.changeSize_();
    }
  };

  CardboardButton.prototype.changeSize_ = function changeSize_() {
    this.player_.width(window$1.innerWidth);
    this.player_.height(window$1.innerHeight);
    window$1.dispatchEvent(new window$1.Event('resize'));
  };

  CardboardButton.prototype.handleVrDisplayActivate_ = function handleVrDisplayActivate_() {
    // we mimic fullscreen on IOS
    if (videojs.browser.IS_IOS) {
      this.oldWidth_ = this.player_.currentWidth();
      this.oldHeight_ = this.player_.currentHeight();
      this.player_.enterFullWindow();
      this.changeSize_();
    }

    this.active_ = true;
  };

  CardboardButton.prototype.handleVrDisplayDeactivate_ = function handleVrDisplayDeactivate_() {
    // un-mimic fullscreen on iOS
    if (videojs.browser.IS_IOS) {
      if (this.oldWidth_) {
        this.player_.width(this.oldWidth_);
      }
      if (this.oldHeight_) {
        this.player_.height(this.oldHeight_);
      }
      this.player_.exitFullWindow();
      window$1.dispatchEvent(new window$1.Event('resize'));
    }

    this.active_ = false;
  };

  CardboardButton.prototype.handleClick = function handleClick(event) {
    // if cardboard mode display is not active, activate it
    // otherwise deactivate it
    if (!this.active_) {
      // This starts playback mode when the cardboard button
      // is clicked on Andriod. We need to do this as the controls
      // disappear
      if (!this.player_.hasStarted() && videojs.browser.IS_ANDROID) {
        this.player_.play();
      }
      window$1.dispatchEvent(new window$1.Event('vrdisplayactivate'));
    } else {
      window$1.dispatchEvent(new window$1.Event('vrdisplaydeactivate'));
    }
  };

  CardboardButton.prototype.dispose = function dispose() {
    _Button.prototype.dispose.call(this);
    window$1.removeEventListener('vrdisplayactivate', this.handleVrDisplayActivate_);
    window$1.removeEventListener('vrdisplaydeactivate', this.handleVrDisplayDeactivate_);
    window$1.removeEventListener('vrdisplaypresentchange', this.handleVrDisplayPresentChange_);
  };

  return CardboardButton;
}(Button);

videojs.registerComponent('CardboardButton', CardboardButton);

var BigPlayButton = videojs.getComponent('BigPlayButton');

var BigVrPlayButton = function (_BigPlayButton) {
  inherits(BigVrPlayButton, _BigPlayButton);

  function BigVrPlayButton() {
    classCallCheck(this, BigVrPlayButton);
    return possibleConstructorReturn(this, _BigPlayButton.apply(this, arguments));
  }

  BigVrPlayButton.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-big-vr-play-button ' + _BigPlayButton.prototype.buildCSSClass.call(this);
  };

  return BigVrPlayButton;
}(BigPlayButton);

videojs.registerComponent('BigVrPlayButton', BigVrPlayButton);

/* THIS CONFIGURES webvr-polyfill don't change the order */
// previously we used
// * three/examples/js/controls/VRControls.js
// * three/examples/js/effects/VREffects.js
// but since we are using es6 now, there is no good way to make them export to us
// so the code has been copied locally to allow exporting
// import controls so they get regisetered with videojs
window$1.WebVRManager = WebVRManager;

var validProjections = ['360', '360_LR', '360_TB', '360_CUBE', 'NONE', 'AUTO', 'Sphere', 'Cube', 'equirectangular'];

// Default options for the plugin.
var defaults$$1 = {
  projection: 'AUTO',
  forceCardboard: false,
  debug: false
};

var errors = {
  'web-vr-no-devices-found': {
    headline: 'No 360 devices found',
    type: '360_NO_DEVICES_FOUND',
    message: 'Your browser supports 360, but no 360 displays found.'
  },
  'web-vr-out-of-date': {
    headline: '360 is out of date',
    type: '360_OUT_OF_DATE',
    message: "Your browser supports 360 but not the latest version. See <a href='http://webvr.info'>webvr.info</a> for more info."
  },
  'web-vr-not-supported': {
    headline: '360 not supported on this device',
    type: '360_NOT_SUPPORTED',
    message: "Your browser does not support 360. See <a href='http://webvr.info'>webvr.info</a> for assistance."
  }
};

var getInternalProjectionName = function getInternalProjectionName(projection) {
  if (!projection) {
    return;
  }

  projection = projection.toString().trim();

  if (/sphere/i.test(projection)) {
    return '360';
  }

  if (/cube/i.test(projection)) {
    return '360_CUBE';
  }

  if (/equirectangular/i.test(projection)) {
    return '360';
  }

  for (var i = 0; i < validProjections.length; i++) {
    if (new RegExp('^' + validProjections[i] + '$', 'i').test(projection)) {
      return validProjections[i];
    }
  }
};

var isHLS = function isHLS(currentType) {
  // hls video types
  var hlsTypes = [
  // Apple santioned
  'application/vnd.apple.mpegurl',
  // Very common
  'application/x-mpegurl',
  // Included for completeness
  'video/x-mpegurl', 'video/mpegurl', 'application/mpegurl'];

  // if the current type has a case insensitivie match from the list above
  // this is hls
  return hlsTypes.some(function (type) {
    return new RegExp('^' + type + '$', 'i').test(currentType);
  });
};

var Plugin = videojs.getPlugin('plugin');
var Component = videojs.getComponent('Component');

var VR = function (_Plugin) {
  inherits(VR, _Plugin);

  function VR(player, options) {
    classCallCheck(this, VR);

    var settings = videojs.mergeOptions(defaults$$1, options);

    var _this = possibleConstructorReturn(this, _Plugin.call(this, player, settings));

    _this.options_ = settings;
    _this.player_ = player;
    _this.bigPlayButtonIndex_ = player.children().indexOf(player.getChild('BigPlayButton')) || 0;

    // custom videojs-errors integration boolean
    _this.videojsErrorsSupport_ = !!videojs.errors;

    if (_this.videojsErrorsSupport_) {
      player.errors({ errors: errors });
    }

    // we need this as IE 11 reports that it has a VR display, but isnt compatible with Video as a Texture. for example
    if (videojs.browser.IE_VERSION) {
      _this.triggerError_({ code: 'web-vr-not-supported', dismiss: false });
      return possibleConstructorReturn(_this);
    }

    _this.handleVrDisplayActivate_ = videojs.bind(_this, _this.handleVrDisplayActivate_);
    _this.handleVrDisplayDeactivate_ = videojs.bind(_this, _this.handleVrDisplayDeactivate_);
    _this.handleResize_ = videojs.bind(_this, _this.handleResize_);
    _this.animate_ = videojs.bind(_this, _this.animate_);

    _this.setProjection(_this.options_.projection);

    _this.on(player, 'loadedmetadata', _this.init);
    return _this;
  }

  VR.prototype.changeProjection_ = function changeProjection_(projection) {
    projection = getInternalProjectionName(projection);
    // don't change to an invalid projection
    if (!projection) {
      projection = 'NONE';
    }

    var position = { x: 0, y: 0, z: 0 };

    if (this.scene) {
      this.scene.remove(this.movieScreen);
    }
    if (projection === 'AUTO') {
      // mediainfo cannot be set to auto or we would infinite loop here
      // each source should know wether they are 360 or not, if using AUTO
      if (this.player_.mediainfo && this.player_.mediainfo.projection && this.player_.mediainfo.projection !== 'AUTO') {
        var autoProjection = getInternalProjectionName(this.player_.mediainfo.projection);

        return this.changeProjection_(autoProjection);
      }
      return this.changeProjection_('NONE');
    } else if (projection === '360') {
      this.movieGeometry = new SphereBufferGeometry(256, 32, 32);

      this.movieScreen = new Mesh(this.movieGeometry, this.movieMaterial);
      this.movieScreen.position.set(position.x, position.y, position.z);

      this.movieScreen.scale.x = -1;
      this.movieScreen.quaternion.setFromAxisAngle({ x: 0, y: 1, z: 0 }, -Math.PI / 2);
      this.scene.add(this.movieScreen);
    } else if (projection === '360_LR' || projection === '360_TB') {
      var geometry = new SphereGeometry(256, 32, 32);

      // Left eye view
      var uvs = geometry.faceVertexUvs[0];

      for (var i = 0; i < uvs.length; i++) {
        for (var j = 0; j < 3; j++) {
          if (projection === '360_LR') {
            uvs[i][j].x *= 0.5;
          } else {
            uvs[i][j].y *= 0.5;
            uvs[i][j].y += 0.5;
          }
        }
      }
      geometry.scale(-1, 1, 1);

      this.movieGeometry = new BufferGeometry().fromGeometry(geometry);
      this.movieScreen = new Mesh(this.movieGeometry, this.movieMaterial);
      this.movieScreen.rotation.y = -Math.PI / 2;
      // display in left eye only
      this.movieScreen.layers.set(1);
      this.scene.add(this.movieScreen);

      // Right eye view
      geometry = new SphereGeometry(256, 32, 32);

      uvs = geometry.faceVertexUvs[0];

      for (var _i = 0; _i < uvs.length; _i++) {
        for (var _j = 0; _j < 3; _j++) {
          if (projection === '360_LR') {
            uvs[_i][_j].x *= 0.5;
            uvs[_i][_j].x += 0.5;
          } else {
            uvs[_i][_j].y *= 0.5;
          }
        }
      }
      geometry.scale(-1, 1, 1);

      this.movieGeometry = new BufferGeometry().fromGeometry(geometry);
      this.movieScreen = new Mesh(this.movieGeometry, this.movieMaterial);
      this.movieScreen.rotation.y = -Math.PI / 2;
      // display in right eye only
      this.movieScreen.layers.set(2);
      this.scene.add(this.movieScreen);
    } else if (projection === '360_CUBE') {
      // Currently doesn't work - need to figure out order of cube faces
      this.movieGeometry = new CubeGeometry(256, 256, 256);
      var face1 = [new Vector2(0, 0.5), new Vector2(0.333, 0.5), new Vector2(0.333, 1), new Vector2(0, 1)];
      var face2 = [new Vector2(0.333, 0.5), new Vector2(0.666, 0.5), new Vector2(0.666, 1), new Vector2(0.333, 1)];
      var face3 = [new Vector2(0.666, 0.5), new Vector2(1, 0.5), new Vector2(1, 1), new Vector2(0.666, 1)];
      var face4 = [new Vector2(0, 0), new Vector2(0.333, 1), new Vector2(0.333, 0.5), new Vector2(0, 0.5)];
      var face5 = [new Vector2(0.333, 1), new Vector2(0.666, 1), new Vector2(0.666, 0.5), new Vector2(0.333, 0.5)];
      var face6 = [new Vector2(0.666, 1), new Vector2(1, 0), new Vector2(1, 0.5), new Vector2(0.666, 0.5)];

      this.movieGeometry.faceVertexUvs[0] = [];

      this.movieGeometry.faceVertexUvs[0][0] = [face1[0], face1[1], face1[3]];
      this.movieGeometry.faceVertexUvs[0][1] = [face1[1], face1[2], face1[3]];

      this.movieGeometry.faceVertexUvs[0][2] = [face2[0], face2[1], face2[3]];
      this.movieGeometry.faceVertexUvs[0][3] = [face2[1], face2[2], face2[3]];

      this.movieGeometry.faceVertexUvs[0][4] = [face3[0], face3[1], face3[3]];
      this.movieGeometry.faceVertexUvs[0][5] = [face3[1], face3[2], face3[3]];

      this.movieGeometry.faceVertexUvs[0][6] = [face4[0], face4[1], face4[3]];
      this.movieGeometry.faceVertexUvs[0][7] = [face4[1], face4[2], face4[3]];

      this.movieGeometry.faceVertexUvs[0][8] = [face5[0], face5[1], face5[3]];
      this.movieGeometry.faceVertexUvs[0][9] = [face5[1], face5[2], face5[3]];

      this.movieGeometry.faceVertexUvs[0][10] = [face6[0], face6[1], face6[3]];
      this.movieGeometry.faceVertexUvs[0][11] = [face6[1], face6[2], face6[3]];

      this.movieScreen = new Mesh(this.movieGeometry, this.movieMaterial);
      this.movieScreen.position.set(position.x, position.y, position.z);

      this.scene.add(this.movieScreen);
    }

    this.currentProjection_ = projection;
  };

  VR.prototype.triggerError_ = function triggerError_(errorObj) {
    // if we have videojs-errors use it
    if (this.videojsErrorsSupport_) {
      this.player_.error(errorObj);
      // if we don't have videojs-errors just use a normal player error
    } else {
      this.player_.error({ code: errorObj.code, message: errors[errorObj.code].message });
    }
  };

  VR.prototype.log = function log(msg) {
    if (this.options_.debug) {
      videojs.log(msg);
    }
  };

  VR.prototype.handleVrDisplayActivate_ = function handleVrDisplayActivate_() {
    this.manager.enterVRMode_();
    this.manager.setMode_(3);
  };

  VR.prototype.handleVrDisplayDeactivate_ = function handleVrDisplayDeactivate_() {
    if (!this.vrDisplay.isPresenting) {
      return;
    }
    this.vrDisplay.exitPresent();
  };

  VR.prototype.togglePlay_ = function togglePlay_() {
    if (this.player_.paused()) {
      this.player_.play();
    } else {
      this.player_.pause();
    }
  };

  VR.prototype.animate_ = function animate_() {
    if (this.getVideoEl_().readyState === this.getVideoEl_().HAVE_ENOUGH_DATA) {
      if (this.videoTexture) {
        this.videoTexture.needsUpdate = true;
      }
    }

    this.controls3d.update();
    this.manager.render(this.scene, this.camera);

    if (!this.vrDisplay) {
      this.animationFrameId_ = this.requestAnimationFrame(this.animate_);
      this.camera.getWorldDirection(this.cameraVector);
      return;
    }

    this.animationFrameId_ = this.vrDisplay.requestAnimationFrame(this.animate_);

    if (!window$1.navigator.getGamepads) {
      return;
    }
    // Grab all gamepads
    var gamepads = window$1.navigator.getGamepads();

    for (var i = 0; i < gamepads.length; ++i) {
      var gamepad = gamepads[i];

      // Make sure gamepad is defined
      if (!gamepad) {
        continue;
      }
      // Only take input if state has changed since we checked last
      if (gamepad.timestamp && !(gamepad.timestamp === this.prevTimestamps_[i])) {
        for (var j = 0; j < gamepad.buttons.length; ++j) {
          if (gamepad.buttons[j].pressed) {
            this.togglePlay_();
            this.prevTimestamps_[i] = gamepad.timestamp;
            break;
          }
        }
      }
    }
    this.camera.getWorldDirection(this.cameraVector);
  };

  VR.prototype.handleResize_ = function handleResize_() {
    var width = this.player_.currentWidth();
    var height = this.player_.currentHeight();

    this.effect.setSize(width, height, false);
    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();
  };

  VR.prototype.setProjection = function setProjection(projection) {

    if (!getInternalProjectionName(projection)) {
      videojs.log.error('videojs-vr: please pass a valid projection: ' + validProjections.join(', '));
      return;
    }

    this.currentProjection_ = projection;
    this.defaultProjection_ = projection;
  };

  VR.prototype.init = function init() {
    var _this2 = this;

    this.reset();

    this.camera = new PerspectiveCamera(75, this.player_.currentWidth() / this.player_.currentHeight(), 1, 1000);
    // Store vector representing the direction in which the camera is looking, in world space.
    this.cameraVector = new Vector3();

    if (this.currentProjection_ === '360_LR' || this.currentProjection_ === '360_TB') {
      // Render left eye when not in VR mode
      this.camera.layers.enable(1);
    }

    this.scene = new Scene();
    this.controls3d = new VRControls(this.camera);

    this.videoTexture = new VideoTexture(this.getVideoEl_());

    this.videoTexture.generateMipmaps = false;
    this.videoTexture.minFilter = LinearFilter;
    this.videoTexture.magFilter = LinearFilter;

    // iOS and macOS HLS fix/hacks
    // https://bugs.webkit.org/show_bug.cgi?id=163866#c3
    // https://github.com/mrdoob/three.js/issues/9754
    // On iOS with HLS, color space is wrong and texture is flipped on Y axis
    // On macOS, just need to flip texture Y axis

    if (isHLS() && videojs.browser.IS_ANY_SAFARI) {
      this.log('Safari + iOS + HLS = flipY and colorspace hack');
      this.videoTexture.format = RGBAFormat;
      this.videoTexture.flipY = false;
    } else if (isHLS() && videojs.browser.IS_SAFARI) {
      this.log('Safari + HLS = flipY hack');
      this.videoTexture.format = RGBFormat;
      this.videoTexture.flipY = false;
    } else {
      this.videoTexture.format = RGBFormat;
    }

    if (this.videoTexture.format === RGBAFormat && this.videoTexture.flipY === false) {
      this.movieMaterial = new ShaderMaterial({
        uniforms: {
          texture: { value: this.videoTexture }
        },
        vertexShader: ['varying vec2 vUV;', 'void main() {', ' vUV = vec2( uv.x, 1.0 - uv.y );', ' gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );', '}'].join('\n'),
        fragmentShader: ['uniform sampler2D texture;', 'varying vec2 vUV;', 'void main() {', ' gl_FragColor = texture2D( texture, vUV  ).bgra;', '}'].join('\n')
      });
    } else if (this.videoTexture.format === RGBFormat && this.videoTexture.flipY === false) {
      this.movieMaterial = new ShaderMaterial({
        uniforms: {
          texture: { value: this.videoTexture }
        },
        vertexShader: ['varying vec2 vUV;', 'void main() {', ' vUV = vec2( uv.x, 1.0 - uv.y );', ' gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );', '}'].join('\n'),
        fragmentShader: ['uniform sampler2D texture;', 'varying vec2 vUV;', 'void main() {', ' gl_FragColor = texture2D( texture, vUV  );', '}'].join('\n')
      });
    } else {
      this.movieMaterial = new MeshBasicMaterial({ map: this.videoTexture, overdraw: true, side: DoubleSide });
    }

    this.changeProjection_(this.currentProjection_);

    if (this.currentProjection_ === 'NONE') {
      this.log('Projection is NONE, dont init');
      this.reset();
      return;
    }

    this.player_.removeChild('BigPlayButton');
    this.player_.addChild('BigVrPlayButton', {}, this.bigPlayButtonIndex_);
    this.player_.bigPlayButton = this.player_.getChild('BigVrPlayButton');

    // mobile devices, or cardboard forced to on
    if (this.options_.forceCardboard || videojs.browser.IS_ANDROID || videojs.browser.IS_IOS) {
      this.addCardboardButton_();
    }

    // if ios remove full screen toggle
    if (videojs.browser.IS_IOS) {
      this.player_.controlBar.fullscreenToggle.hide();
    }

    this.camera.position.set(0, 0, 0);
    this.renderer = new WebGLRenderer({
      devicePixelRatio: window$1.devicePixelRatio,
      alpha: false,
      clearColor: 0xffffff,
      antialias: true
    });

    this.renderer.setSize(this.player_.currentWidth(), this.player_.currentHeight(), false);
    this.effect = new VREffect(this.renderer);

    this.effect.setSize(this.player_.currentWidth(), this.player_.currentHeight(), false);
    this.vrDisplay = null;

    // Previous timestamps for gamepad updates
    this.prevTimestamps_ = [];

    this.manager = new WebVRManager(this.renderer, this.effect, { hideButton: true });

    this.renderedCanvas = this.renderer.domElement;

    var debounce = function debounce(fn, wait) {
      var timeout = void 0;

      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        // reset the timer
        if (timeout) {
          window$1.clearTimeout(timeout);
        }
        timeout = window$1.setTimeout(function () {
          return fn.apply(undefined, args);
        }, wait);
      };
    };
    // we use this to stop webvr-polyfill from making the canvas take up more
    // space then the video element
    var setInherit = debounce(function (mut) {
      if (_this2.observer_) {
        _this2.observer_.disconnect();
      } else {
        _this2.observer_ = new window$1.MutationObserver(setInherit);
      }
      _this2.renderedCanvas.setAttribute('style', 'width: inherit; height: inherit;');
      _this2.handleResize_();
      _this2.observer_.observe(_this2.renderedCanvas, {
        attributes: true,
        attributeList: ['style']
      });
    }, 10);

    setInherit();

    this.player_.el().insertBefore(this.renderedCanvas, this.player_.el().firstChild);
    this.getVideoEl_().style.display = 'none';

    if (window$1.navigator.getVRDisplays) {
      window$1.navigator.getVRDisplays().then(function (displays) {
        if (displays.length > 0) {
          _this2.log('WebVR supported, VRDisplays found.');
          _this2.vrDisplay = displays[0];
          _this2.log(_this2.vrDisplay);

          // Native WebVR Head Mounted Displays (HMDs) like the HTC Vive
          // also need the cardboard button to enter fully immersive mode
          // so, we want to add the button if we're not polyfilled.
          if (!_this2.vrDisplay.isPolyfilled) {
            _this2.addCardboardButton_();
          }
        } else {
          _this2.triggerError_({ code: 'web-vr-no-devices-found', dismiss: false });
        }
      });
    } else if (window$1.navigator.getVRDevices) {
      this.triggerError_({ code: 'web-vr-out-of-date', dismiss: false });
    } else {
      this.triggerError_({ code: 'web-vr-not-supported', dismiss: false });
    }

    this.on(this.player_, 'fullscreenchange', this.handleResize_);
    window$1.addEventListener('vrdisplaypresentchange', this.handleResize_, true);
    window$1.addEventListener('resize', this.handleResize_, true);
    window$1.addEventListener('vrdisplayactivate', this.handleVrDisplayActivate_, true);
    window$1.addEventListener('vrdisplaydeactivate', this.handleVrDisplayDeactivate_, true);

    this.animate_();
    this.initialized_ = true;
  };

  VR.prototype.addCardboardButton_ = function addCardboardButton_() {
    if (!this.player_.controlBar.getChild('CardboardButton')) {
      this.player_.controlBar.addChild('CardboardButton', {});
    }
  };

  VR.prototype.getVideoEl_ = function getVideoEl_() {
    return this.player_.el().getElementsByTagName('video')[0];
  };

  VR.prototype.reset = function reset() {
    if (!this.initialized_) {
      return;
    }

    if (this.controls3d) {
      this.controls3d.dispose();
    }
    if (this.effect) {
      this.effect.dispose();
    }

    window$1.removeEventListener('resize', this.handleResize_);
    window$1.removeEventListener('vrdisplaypresentchange', this.handleResize_);
    window$1.removeEventListener('vrdisplayactivate', this.handleVrDisplayActivate_);
    window$1.removeEventListener('vrdisplaydeactivate', this.handleVrDisplayDeactivate_);

    // re-add the big play button to player
    if (!this.player_.getChild('BigPlayButton')) {
      this.player_.addChild('BigPlayButton', {}, this.bigPlayButtonIndex_);
    }

    if (this.player_.getChild('BigVrPlayButton')) {
      this.player_.removeChild('BigVrPlayButton');
    }

    // remove the cardboard button
    if (this.player_.getChild('CardboardButton')) {
      this.player_.controlBar.removeChild('CardboardButton');
    }

    // show the fullscreen again
    if (videojs.browser.IS_IOS) {
      this.player_.controlBar.fullscreenToggle.show();
    }

    // reset the video element style so that it will be displayed
    this.getVideoEl_().style.display = '';

    // set the current projection to the default
    this.currentProjection_ = this.defaultProjection;

    if (this.observer_) {
      this.observer_.disconnect();
    }

    // remove the old canvas
    if (this.renderedCanvas) {
      this.renderedCanvas.parentNode.removeChild(this.renderedCanvas);
    }

    if (this.animationFrameId_) {
      this.cancelAnimationFrame(this.animationFrameId_);
    }

    this.initialized_ = false;
  };

  VR.prototype.dispose = function dispose() {
    _Plugin.prototype.dispose.call(this);
    this.reset();
  };

  return VR;
}(Plugin);

VR.prototype.requestAnimationFrame = Component.prototype.requestAnimationFrame;
VR.prototype.cancelAnimationFrame = Component.prototype.cancelAnimationFrame;
VR.prototype.setTimeout = Component.prototype.setTimeout;
VR.prototype.clearTimeout = Component.prototype.clearTimeout;

VR.version = version;

videojs.registerPlugin('vr', VR);

export default VR;



//////////////////
// WEBPACK FOOTER
// ./node_modules/videojs-vr/dist/videojs-vr.es.js
// module id = 583
// module chunks = 1